export default "__VITE_ASSET__CNC4U7sh__"